export function formatClientSummary(clients = [], maxVisible = 3) {
  if (!clients.length) return 'No requirements';
  if (clients.length <= maxVisible) return clients.join(', ');
  return `${clients.slice(0, maxVisible).join(', ')} +${clients.length - maxVisible}`;
}
